export const TIME_ENTRY_STYLE_KEY = "time_entry_style";
export const LOCATION_MRU_SHOW_KEY = "show_location_mru";
export const LOCATION_MRU_DAYS_BACK_KEY = "mru_look_back_days";
export const MONTH_FILTER_PREFERENCE_KEY = "current_preference";
export const SELECTED_TICKET_ID_KEY = "selected_id";
export const APPLICATION_VERSION = "V1.2.30";
export const APPLICATION_NAME = "TRIP TICKETS";
export const APPLICATION_TITLE = `${APPLICATION_NAME} ${APPLICATION_VERSION}`;
export const REVISIONS_ALLOWED_DAYS_BACK = 45;

export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm";

// as per Kevin Lindsay email sent 2023/06/16: 285 = Alberta Forestry, 450 = MFLNRO - Fire Suppression, 587 = BC Hydro
// export const MINIMUMS_VISIBLE_COMPANIES = [285, 450, 587];
// as per Jestey in meeting w KK 2023/08/22 removed BC Hydro
export const MINIMUMS_VISIBLE_COMPANIES = [285, 450];

// add kellyco for testing on
// export const MINIMUMS_VISIBLE_COMPANIES = [285, 450, 488];

// magic values to find the right edit form for line items with no type id
export const DUMMY_FUEL_LINE_ITEM_TYPE = Number.MAX_SAFE_INTEGER;
export const DUMMY_CHARGE_LINE_ITEM_TYPE = Number.MAX_SAFE_INTEGER - 1;

export const PER_DIEMS_LINE_ITEM_TYPES = [1, 2, 3, 4, 5];
export const OTHER_CHARGES_LINE_ITEM_TYPES = [DUMMY_CHARGE_LINE_ITEM_TYPE, 6, 7, 8, 9, 10];
export const CHARGE_LINE_ITEM_TYPES = [...PER_DIEMS_LINE_ITEM_TYPES, ...OTHER_CHARGES_LINE_ITEM_TYPES];

// wow this hardcoding is ugly. is there a better way? not sure if these are really line items
export const MIN_HELI = 11;
export const MIN_PILOT = 12;

// as per Jestey phone call w KK and PR 2023/08/22 do not show pilot mins on card or pdf
// export const MINIMUM_LINE_ITEM_TYPES = [MIN_HELI, MIN_PILOT];
export const MINIMUM_LINE_ITEM_TYPES = [MIN_HELI];
export const RATE_CHARTER = 14;
export const RATE_UNUSED = 13;
export const RATE_LINE_ITEM_TYPES = [RATE_CHARTER, RATE_UNUSED];
export const RATES_AND_MINS_LINE_ITEM_TYPES = [...MINIMUM_LINE_ITEM_TYPES, ...RATE_LINE_ITEM_TYPES];
export const FUEL_BASE_OPERATOR = 15;
export const FUEL_REMOTE_OPERATOR = 17;
export const FUEL_REMOTE_CUSTOMER = 18;
export const FUEL_BASE_LINE_ITEM_TYPES = [FUEL_BASE_OPERATOR];
export const FUEL_REMOTE_LINE_ITEM_TYPES = [FUEL_REMOTE_OPERATOR, FUEL_REMOTE_CUSTOMER];
export const FUEL_LINE_ITEM_TYPES = [DUMMY_FUEL_LINE_ITEM_TYPE, ...FUEL_BASE_LINE_ITEM_TYPES, ...FUEL_REMOTE_LINE_ITEM_TYPES];
export const LANDING_LINE_ITEM_TYPE = 19;
export const LANDING_LINE_ITEM_TYPES = [LANDING_LINE_ITEM_TYPE];

// TODO should we do the work of looking these up in code? at any rate they probably shouldn't live here
export const QUANTITY_TYPE_AMOUNT = 1;
export const QUANTITY_TYPE_HOURS = 2;
export const QUANTITY_TYPE_LITRES = 3;
export const EMERGENCY_CONTACT_ASSIGNABLE_ID = 17;
